/*
  VALUAN - BRINDE AUTOMATICO NO CARRINHO

  Regras vem do bloco "Card com produto" (vt_card) da pagina de produto:
  <script type="application/json" data-vt-brinde>{"gatilho": 123, "brinde": 456, "max": 1}</script>

  - Produto gatilho no carrinho e brinde ausente: adiciona o brinde (com a propriedade
    oculta _vt_brinde = id do gatilho).
  - Gatilho saiu do carrinho: remove o brinde.
  - Quantidade do brinde acima do maximo: volta para o maximo.
  - Brinde cobrado (o desconto nao combinou com outra oferta do carrinho): tira o brinde,
    para nunca cobrar o cliente, e nao tenta de novo enquanto os produtos forem os mesmos.

  No botao "Adicionar" da pagina do produto o brinde vai no MESMO pedido do relogio
  (brinde primeiro, para o relogio ficar em cima na gaveta). Assim a gaveta abre uma vez,
  ja com os dois itens. A conciliacao acima continua como rede de seguranca.

  O preco zero vem do desconto automatico da Shopify, nao deste script. Este script so
  coloca e tira a linha do brinde. Ele so mexe em linhas marcadas com _vt_brinde, entao
  nao interfere nas outras ofertas do carrinho.
*/
(() => {
  const CHAVE = 'vtBrindeRegras';
  const VALIDADE = 7 * 24 * 60 * 60 * 1000;
  const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let ocupado = false;
  let pendente = false;

  // Regras da pagina atual + regras guardadas de paginas de produto visitadas
  // (assim a remocao e a adicao funcionam tambem no carrinho de outras paginas).
  const lerRegras = () => {
    const regras = {};
    try {
      const salvas = JSON.parse(localStorage.getItem(CHAVE) || '{}');
      Object.keys(salvas).forEach((k) => {
        if (Date.now() - salvas[k].t < VALIDADE) regras[k] = salvas[k];
      });
    } catch (e) {}

    document.querySelectorAll('script[data-vt-brinde]').forEach((el) => {
      try {
        const r = JSON.parse(el.textContent);
        if (r.gatilho && r.brinde) regras[r.gatilho] = { ...r, t: Date.now() };
      } catch (e) {}
    });

    try {
      localStorage.setItem(CHAVE, JSON.stringify(regras));
    } catch (e) {}

    return Object.values(regras);
  };

  const pedir = (url, corpo) =>
    fetch(raiz + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo),
    });

  const lerCarrinho = async () => (await fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })).json();

  // Produtos do carrinho, sem os brindes. Muda quando o cliente adiciona ou tira algo.
  const assinatura = (itens) =>
    itens
      .filter((i) => !(i.properties && i.properties._vt_brinde))
      .map((i) => i.product_id)
      .sort()
      .join(',');

  const BLOQUEIO = 'vtBrindeBloqueio';
  const lerBloqueio = () => {
    try {
      return sessionStorage.getItem(BLOQUEIO);
    } catch (e) {
      return null;
    }
  };
  const gravarBloqueio = (valor) => {
    try {
      sessionStorage.setItem(BLOQUEIO, valor);
    } catch (e) {}
  };

  const conciliar = async (carrinho) => {
    if (ocupado) {
      pendente = true;
      return;
    }
    ocupado = true;

    try {
      carrinho = carrinho || (await lerCarrinho());
      ultimoCarrinho = carrinho;
      const regras = lerRegras();
      const itens = carrinho.items || [];
      const temProduto = (id) => itens.some((i) => String(i.product_id) === String(id) && !(i.properties && i.properties._vt_brinde));
      const mudancas = [];
      const atendidos = {};

      const atual = assinatura(itens);
      const bloqueado = lerBloqueio() === atual;

      // 1. Linhas de brinde: tira sem gatilho, tira se estiver sendo cobrado, limita quantidade, tira duplicadas
      itens.forEach((i) => {
        const gatilho = i.properties && i.properties._vt_brinde;
        if (!gatilho) return;

        const regra = regras.find((r) => String(r.gatilho) === String(gatilho));
        const max = (regra && regra.max) || 1;

        if (!temProduto(gatilho) || atendidos[gatilho]) {
          mudancas.push({ id: i.key, quantity: 0 });
        } else if (i.final_line_price > 0) {
          mudancas.push({ id: i.key, quantity: 0 });
          gravarBloqueio(atual);
        } else {
          atendidos[gatilho] = true;
          if (i.quantity > max) mudancas.push({ id: i.key, quantity: max });
        }
      });

      for (const m of mudancas) await pedir('cart/change.js', m);

      // 2. Gatilho no carrinho sem brinde: adiciona (menos quando o desconto ja falhou com estes produtos)
      const adicionar = lerBloqueio() === atual || bloqueado
        ? []
        : regras
            .filter((r) => temProduto(r.gatilho) && !atendidos[r.gatilho])
            .map((r) => ({ id: r.brinde, quantity: r.max || 1, properties: { _vt_brinde: String(r.gatilho) } }));

      if (adicionar.length) {
        await pedir('cart/add.js', { items: adicionar });

        // Confere se o desconto pegou. Se o brinde saiu cobrado, tira na hora.
        const depois = await lerCarrinho();
        for (const i of depois.items || []) {
          if (i.properties && i.properties._vt_brinde && i.final_line_price > 0) {
            await pedir('cart/change.js', { id: i.key, quantity: 0 });
            gravarBloqueio(assinatura(depois.items));
          }
        }
      }

      if (mudancas.length || adicionar.length) {
        if (/\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      }
    } catch (e) {
      // Falha de rede: o carrinho segue como esta, sem travar a compra.
    } finally {
      ocupado = false;
      if (pendente) {
        pendente = false;
        setTimeout(() => conciliar(), 300);
      }
    }
  };

  // Ultimo carrinho conhecido, para saber se o brinde ja esta la antes de juntar no pedido.
  let ultimoCarrinho = null;
  const brindeNoCarrinho = (gatilho) =>
    !!(ultimoCarrinho && (ultimoCarrinho.items || []).some((i) => i.properties && String(i.properties._vt_brinde) === String(gatilho)));

  const regrasDaPagina = () =>
    Array.from(document.querySelectorAll('script[data-vt-brinde]'))
      .map((el) => {
        try {
          return JSON.parse(el.textContent);
        } catch (e) {
          return null;
        }
      })
      .filter((r) => r && r.brinde && Array.isArray(r.variantes));

  // Junta o brinde no pedido de "Adicionar" do relogio. So mexe em POST /cart/add com
  // FormData cuja variante e de um produto gatilho; qualquer outro pedido passa intacto.
  const fetchOriginal = window.fetch;
  window.fetch = function (entrada, opcoes) {
    try {
      const url = typeof entrada === 'string' ? entrada : entrada && entrada.url;
      const corpo = opcoes && opcoes.body;

      if (url && /\/cart\/add(\.js)?(\?|$)/.test(url) && typeof FormData !== 'undefined' && corpo instanceof FormData && corpo.has('id') && !corpo.has('items[0][id]')) {
        const variante = Number(corpo.get('id'));
        const regra = regrasDaPagina().find((r) => r.variantes.indexOf(variante) !== -1);

        if (regra && !brindeNoCarrinho(regra.gatilho) && !lerBloqueio()) {
          const novo = new FormData();
          novo.append('items[0][id]', regra.brinde);
          novo.append('items[0][quantity]', regra.max || 1);
          novo.append('items[0][properties][_vt_brinde]', String(regra.gatilho));
          novo.append('items[1][id]', variante);
          novo.append('items[1][quantity]', corpo.get('quantity') || 1);

          corpo.forEach((valor, chave) => {
            const prop = chave.match(/^properties\[(.+)\]$/);
            if (prop) novo.append('items[1][properties][' + prop[1] + ']', valor);
            else if (chave === 'selling_plan') novo.append('items[1][selling_plan]', valor);
            else if (chave === 'sections' || chave === 'sections_url') novo.append(chave, valor);
          });

          return fetchOriginal.call(this, entrada, { ...opcoes, body: novo });
        }
      }
    } catch (e) {
      // Em qualquer falha aqui, segue o pedido original sem brinde (a conciliacao cobre depois).
    }
    return fetchOriginal.apply(this, arguments);
  };

  document.addEventListener('cart:change', (evento) => {
    const carrinho = evento.detail && evento.detail.cart;
    if (carrinho && carrinho.items) ultimoCarrinho = carrinho;
    conciliar(carrinho && carrinho.items ? carrinho : null);
  });

  const iniciar = () => {
    if (lerRegras().length) conciliar();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
